import React, { FunctionComponent, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './text-feature-with-description.module.scss';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { TextAlignType } from '../../typings';
import { checkIfDecimal } from '../../utils/utils';

export interface ITextFeatureWithDescriptionProps {
  theme: string;
  featureText: string;
  featureTextAligment: TextAlignType;
  featureTextWeight: string;
  description: string;
  descriptionTextAligment: TextAlignType;
  descriptionTextWeight: string;
  hasCountingAnimation?: boolean;
  countingNumberPrefix?: string;
  countingNumberSufix?: string;
}

const cx = classNames.bind(styles);

export const TextFeatureWithDescription: FunctionComponent<ITextFeatureWithDescriptionProps> = props => {
  const {
    theme,
    featureText,
    featureTextAligment,
    featureTextWeight,
    description,
    descriptionTextAligment,
    descriptionTextWeight,
    hasCountingAnimation,
    countingNumberPrefix,
    countingNumberSufix
  } = props;

  const [viewPortEntered, setViewPortEntered] = useState(false);

  const themeVariant = theme || 'primary';

  const featureTextClasses = cx(featureTextAligment, featureTextWeight);
  const descriptionClasses = cx(descriptionTextAligment, descriptionTextWeight);

  let countUpAnimation;

  if (hasCountingAnimation) {
    countUpAnimation = (
      <CountUp
        start={viewPortEntered ? null : 0}
        end={+featureText}
        duration={3}
        decimals={checkIfDecimal(featureText) ? 1 : 0}
        decimal={','}
        delay={0}
        prefix={countingNumberPrefix}
        suffix={countingNumberSufix}
      >
        {({ countUpRef }): JSX.Element => (
          <VisibilitySensor
            active={!viewPortEntered}
            onChange={(isVisible: boolean): void => {
              if (isVisible) {
                setViewPortEntered(true);
              }
            }}
            delayedCall
          >
            <React.Fragment>
              <div
                ref={countUpRef}
                className={`${styles.featureText} ${featureTextClasses}`}
              ></div>
              <p className={`${styles.description} ${descriptionClasses}`}>
                {description}
              </p>
            </React.Fragment>
          </VisibilitySensor>
        )}
      </CountUp>
    );
  }

  return (
    <div data-theme={`theme-${themeVariant}`} className={styles.wrapper}>
      {hasCountingAnimation ? (
        countUpAnimation
      ) : (
        <React.Fragment>
          <div className={`${styles.featureText} ${featureTextClasses}`}>
            {featureText}
          </div>
          <p className={`${styles.description} ${descriptionClasses}`}>
            {description}
          </p>
        </React.Fragment>
      )}
    </div>
  );
};
